import { gql } from "generated-graphql";

export const HARMONIZED_VIOLATIONS = gql(`
  query HarmonizedViolations(
    $tenantId: ID!
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    harmonizedViolations(
      tenantId: $tenantId
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      count
      items {
        id
        violationId
        epaFacilityId
        registryId
        state
        sourceProgram
        violationCode
        violationDescription
        standardizedSeverity
        stdSeverityDeterminantCode
        stdSeverityDeterminantDesc
        orderStatuteCode
        standardizedResolutionStatus
        govStatus
        resolutionMethodDesc
        scheduleEventDesc
        pollutantTypeDesc
        citations
        citationDescs
        violationAgencyLevel
        violationAgency
        epaFacilityLink
        detailLink
        violationStartDate
        violationEndDate
        permitTerminalDate
        priorOccurrenceCount
        matchProvenance
        lastSeenAt
        assigneeSource
        assignee {
          id
          email
          person {
            first
            last
          }
        }
        staffAssigneeIsFacilityDefault
        staffAssignee {
          id
          email
          person {
            first
            last
          }
        }
        facility {
          id
          name
          businessUnit
          department
        }
        siteCount
        isColocationPrimary
        affectedFacilities {
          id
          name
        }
        lastEditedAt
        lastEditedBy {
          id
          email
          person {
            first
            last
          }
        }
      }
    }
  }
`);

export const SET_HARMONIZED_VIOLATION_GOV_STATUS = gql(`
  mutation SetHarmonizedViolationGovStatus(
    $tenantId: ID!
    $id: ID!
    $govStatus: HarmonizedViolationGovStatus
  ) {
    setHarmonizedViolationGovStatus(tenantId: $tenantId, id: $id, govStatus: $govStatus) {
      id
      govStatus
      lastEditedAt
      lastEditedBy {
        id
        email
        person {
          first
          last
        }
      }
    }
  }
`);

export const SET_HARMONIZED_VIOLATION_ASSIGNEE = gql(`
  mutation SetHarmonizedViolationAssignee($tenantId: ID!, $id: ID!, $userId: ID) {
    setHarmonizedViolationAssignee(tenantId: $tenantId, id: $id, userId: $userId) {
      id
      assigneeSource
      assignee {
        id
        email
        person {
          first
          last
        }
      }
      lastEditedAt
      lastEditedBy {
        id
        email
        person {
          first
          last
        }
      }
    }
  }
`);

export const SET_HARMONIZED_VIOLATION_ASSIGNEES = gql(`
  mutation SetHarmonizedViolationAssignees($tenantId: ID!, $ids: [ID!]!, $userId: ID) {
    setHarmonizedViolationAssignees(tenantId: $tenantId, ids: $ids, userId: $userId) {
      id
      assigneeSource
      assignee {
        id
        email
        person {
          first
          last
        }
      }
      lastEditedAt
      lastEditedBy {
        id
        email
        person {
          first
          last
        }
      }
    }
  }
`);

export const SET_HARMONIZED_VIOLATION_FACILITY_DEFAULT_ASSIGNEE = gql(`
  mutation SetHarmonizedViolationFacilityDefaultAssignee(
    $tenantId: ID!
    $facilityId: ID!
    $userId: ID
  ) {
    setHarmonizedViolationFacilityDefaultAssignee(
      tenantId: $tenantId
      facilityId: $facilityId
      userId: $userId
    ) {
      id
      facility {
        id
      }
      user {
        id
        email
        person {
          first
          last
        }
      }
    }
  }
`);

export const SET_HARMONIZED_VIOLATION_STAFF_ASSIGNEE = gql(`
  mutation SetHarmonizedViolationStaffAssignee($tenantId: ID!, $id: ID!, $userId: ID) {
    setHarmonizedViolationStaffAssignee(tenantId: $tenantId, id: $id, userId: $userId) {
      id
      staffAssigneeIsFacilityDefault
      staffAssignee {
        id
        email
        person {
          first
          last
        }
      }
      lastEditedAt
      lastEditedBy {
        id
        email
        person {
          first
          last
        }
      }
    }
  }
`);

export const SET_HARMONIZED_VIOLATION_STAFF_ASSIGNEES = gql(`
  mutation SetHarmonizedViolationStaffAssignees($tenantId: ID!, $ids: [ID!]!, $userId: ID) {
    setHarmonizedViolationStaffAssignees(tenantId: $tenantId, ids: $ids, userId: $userId) {
      id
      staffAssigneeIsFacilityDefault
      staffAssignee {
        id
        email
        person {
          first
          last
        }
      }
      lastEditedAt
      lastEditedBy {
        id
        email
        person {
          first
          last
        }
      }
    }
  }
`);

export const SET_HARMONIZED_VIOLATION_FACILITY_DEFAULT_STAFF_ASSIGNEE = gql(`
  mutation SetHarmonizedViolationFacilityDefaultStaffAssignee(
    $tenantId: ID!
    $facilityId: ID!
    $userId: ID
  ) {
    setHarmonizedViolationFacilityDefaultStaffAssignee(
      tenantId: $tenantId
      facilityId: $facilityId
      userId: $userId
    ) {
      id
      facility {
        id
      }
      user {
        id
        email
        person {
          first
          last
        }
      }
    }
  }
`);

export const HARMONIZED_VIOLATION_DEFAULT_ASSIGNEES = gql(`
  query HarmonizedViolationDefaultAssignees($tenantId: ID!, $facilityId: ID!) {
    harmonizedViolationDefaultAssignees(tenantId: $tenantId, facilityId: $facilityId) {
      facility {
        id
        user {
          id
          email
          person {
            first
            last
          }
        }
      }
      region {
        id
        region
        user {
          id
          email
          person {
            first
            last
          }
        }
      }
      businessUnit {
        id
        businessUnit
        user {
          id
          email
          person {
            first
            last
          }
        }
      }
      facilityStaff {
        id
        user {
          id
          email
          person {
            first
            last
          }
        }
      }
    }
  }
`);

export const HARMONIZED_VIOLATION_STATS = gql(`
  query HarmonizedViolationStats($tenantId: ID!, $search: String) {
    harmonizedViolationStats(tenantId: $tenantId, search: $search) {
      total
      highSeverity
      unresolved
      stale
      facilitiesAffected
      bySeverity {
        key
        label
        count
      }
      byProgram {
        key
        label
        count
      }
      topFacilities {
        facilityId
        facilityName
        count
        byProgramSeverity {
          program
          severity
          count
        }
      }
      byQuarter {
        key
        label
        count
      }
      byAssignee {
        key
        label
        count
      }
      byRegion {
        key
        label
        count
        byProgramSeverity {
          program
          severity
          count
        }
      }
      byBusinessUnit {
        key
        label
        count
        byProgramSeverity {
          program
          severity
          count
        }
      }
      byProgramSeverity {
        program
        severity
        count
      }
      byProgramQuarter {
        key
        label
        program
        count
      }
      byAssigneeSeverity {
        key
        label
        severity
        count
      }
    }
  }
`);

export const LATEST_HARMONIZED_VIOLATION_REFRESH = gql(`
  query LatestHarmonizedViolationRefresh($tenantId: ID!) {
    latestHarmonizedViolationRefresh(tenantId: $tenantId) {
      id
      status
      startedAt
      finishedAt
    }
  }
`);

export const HARMONIZED_VIOLATION_COMMENTS = gql(`
  query HarmonizedViolationComments($tenantId: ID!, $harmonizedViolationId: ID!) {
    harmonizedViolationComments(tenantId: $tenantId, harmonizedViolationId: $harmonizedViolationId) {
      ...CommentThread
      isImportedFromAirtable
    }
  }
`);

export const ADD_HARMONIZED_VIOLATION_COMMENT = gql(`
  mutation AddHarmonizedViolationComment(
    $tenantId: ID!
    $harmonizedViolationId: ID!
    $comment: String!
    $documentIds: [ID!]
  ) {
    addHarmonizedViolationComment(
      tenantId: $tenantId
      harmonizedViolationId: $harmonizedViolationId
      comment: $comment
      documentIds: $documentIds
    ) {
      ...CommentThread
      isImportedFromAirtable
    }
  }
`);

export const DELETE_HARMONIZED_VIOLATION_COMMENT = gql(`
  mutation DeleteHarmonizedViolationComment($tenantId: ID!, $id: ID!) {
    deleteHarmonizedViolationComment(tenantId: $tenantId, id: $id)
  }
`);

export const HARMONIZED_VIOLATION_DOCUMENTS = gql(`
  query HarmonizedViolationDocuments($tenantId: ID!, $harmonizedViolationId: ID!) {
    harmonizedViolationDocuments(tenantId: $tenantId, harmonizedViolationId: $harmonizedViolationId) {
      id
      addedByCommentId
      deleted
      createdAt
      documentTitle
      documentFileExtension
      document {
        id
        title
        fileExtension
      }
    }
  }
`);

export const ATTACH_DOCUMENT_TO_HARMONIZED_VIOLATION = gql(`
  mutation AttachDocumentToHarmonizedViolation(
    $tenantId: ID!
    $harmonizedViolationId: ID!
    $documentId: ID!
  ) {
    attachDocumentToHarmonizedViolation(
      tenantId: $tenantId
      harmonizedViolationId: $harmonizedViolationId
      documentId: $documentId
    ) {
      id
      deleted
    }
  }
`);

export const DETACH_DOCUMENT_FROM_HARMONIZED_VIOLATION = gql(`
  mutation DetachDocumentFromHarmonizedViolation($tenantId: ID!, $id: ID!) {
    detachDocumentFromHarmonizedViolation(tenantId: $tenantId, id: $id) {
      id
      deleted
    }
  }
`);
